<odx-modal-header>
  <odx-area-header i18n="@@modal.takePhoto.header">Foto aufnehmen</odx-area-header>
</odx-modal-header>

<odx-modal-content>
  <video autoplay="true" id="video"></video>
</odx-modal-content>

<odx-modal-footer [class.project-photos-camera-footer]="isProjectPhotosMobileModal">
  <button
    odxButton
    variant="secondary"
    odxModalDismiss
    class="cancel-button"
    [class.project-photos-camera-footer__button]="isProjectPhotosMobileModal"
    i18n="@@global.dismiss"
  >
    Abbrechen
  </button>
  <button
    odxButton
    variant="primary"
    (click)="switchCamera()"
    [disabled]="!!(isLoading$ | async)"
    class="switch-camera-button"
    [class.project-photos-camera-footer__button]="isProjectPhotosMobileModal"
    i18n="@@modal.takePhoto.button.switchCamera"
  >
    Kamera wechseln
  </button>
  <button
    odxButton
    variant="primary"
    (click)="takePhoto()"
    [odxLoadingSpinner]="!!(isLoading$ | async)"
    [odxLoadingSpinnerMinHeight]="isProjectPhotosMobileModal ? 36 : null"
    [disabled]="!!(isLoading$ | async)"
    class="take-photo-button"
    [class.project-photos-camera-footer__button]="isProjectPhotosMobileModal"
    i18n="@@modal.takePhoto.button.takePhoto"
  >
    Foto aufnehmen
  </button>
</odx-modal-footer>
